/**
 * 사이드바에서 지금 경로에 불이 들어올 메뉴 하나.
 *
 * 경로가 여러 메뉴 아래에 걸리면 가장 구체적인(긴) 메뉴만 고른다 —
 * /cases/new 는 "반품 접수"이지 "반품 목록"이 아니다. 상세 화면(/cases/12)처럼
 * 따로 메뉴가 없는 하위 경로는 부모 메뉴("반품 목록")에 붙는다.
 * "/"(대시보드)는 그 화면일 때만 고른다.
 */
export function activeNavPath(menuPaths: readonly string[], pathname: string): string | null {
  let best: string | null = null
  for (const to of menuPaths) {
    const hit = to === "/" ? pathname === "/" : pathname === to || pathname.startsWith(`${to}/`)
    if (hit && (best === null || to.length > best.length)) best = to
  }
  return best
}
